// src/data/coursesConfig.ts
//
// 2026-08-07・②「/courses動的化」で新設。当初は`src/app/courses/page.tsx`に
// COURSES/TOOLSを直書きしていたが、サイドバーのアコーディオン（SidebarCourses.tsx）
// でも同じ一覧を使う必要が生じたため、共通データとして切り出した（Kazuto実機確認で
// 「サイドバーのコースも折りたたみで各コースが並ぶ方が自然」と指摘・2026-08-07）。
//
// 各項目の扱い（Kazuto・CEO確定・2026-08-07）：
// - annual2026：購入ページは意図的に未掲載（PDF販売をAIに読ませない判断）のため
//   purchaseLinksは設定しない。実際の入手経路はアクセスコード。
// - 7days：中身が未完成のプレースホルダーのみのため comingSoon 扱い。
// - 思考展開ワーク・タイムフロー：/editionsのワークツールと同一内容（リンクの重複は許容）。
//
// ③ 新規年間アクセス（カードタイプ別・2026-08-07 CEO確定→2026-08-07 CTO室で型を追加）：
// - annual2026の型をカードタイプごとに複製する構想（Room非依存）。既存annual2026購入者の
//   体験（まとめて1年分）を守るため、実コンテンツ投入時は必ず月毎（または翌月分）解放のみとし、
//   一括解放は絶対に持たせない制約が確定済み（CEO確定・2026-08-07）。
// - 実コンテンツ（365日分のお題×カードタイプ）・価格・購入導線とも未確定のため、
//   現時点ではcomingSoon（準備中）の型のみを用意する。ページ・API・エンタイトルメント判定は
//   コンテンツと価格が固まってから着手する。
// - 【8/7・Kazuto決定→8/8・CEO再指示で上書き】上記5件は当初adminOnly:true（テスト/管理者
//   アカウントにのみ表示）としていたが、CEOより「admin限定表示のままではなく表示自体を
//   止めてほしい」と再指示（2026-08-08）。理由：コースの中身（54の断章方式）自体が
//   まだ確定していないため。adminOnly判定ロジック（TEST_ADMIN_UIDS）はコード上は残すが、
//   hidden:trueが優先され管理者を含め誰にも表示されない。
// - 【8/8・CEO指示】7daysも同じ理由でhidden:trueに変更（もともとcomingSoon表示だったが、
//   中身未確定のものを一覧に出すこと自体を当面やめる方針に統一）。
// - 表示判定は src/app/courses/page.tsx・src/components/Sidebar/SidebarCourses.tsx で行う
//   （hidden:trueの項目は一覧から除外。adminOnly/TEST_ADMIN_UIDSの仕組みは将来
//   「まず管理者だけに戻す」場合に備えて温存）。
// - 【8/8・CEO指示・急ぎでなくてよい】5件のdescriptionは現在annual2026の構造（365日の
//   お題＋月ごとのガイド）をそのまま流用した文言になっており、2026-08-08確定の新しい
//   制作方針（54の断章・週刊配信・本棚からの選書）とズレている。次にhiddenを解除する
//   タイミングまでに、新方針に沿った文言へ差し替えること（未着手）。

export type CourseItem = {
  courseId: string;
  label: string;
  description: string;
  href: string;
  purchaseLinks?: { label: string; url: string }[];
  comingSoon?: boolean;
  adminOnly?: boolean;
  hidden?: boolean;
  // 2026-09-09・TASKS_ACTIVE.md 8/23〜9/9エントリ「1万円層コースの購入導線構築」参照。
  // purchaseLinksがある商品は既定でDiscovery/Discovery Pro会員・D30トライアル中でも
  // 自動解放される仕様（courses/page.tsx・SidebarCourses.tsxのhasPlanOrTrialAccess判定）だが、
  // course_standardはサブスクと別建ての単体商品のため、この自動解放を無効化する必要がある
  // （8/26・Kazuto確認「サブスク会員・トライアル中も自動解放させず購入者限定」で確定）。
  // trueの項目はpurchaseLinksが設定されていてもhasPlanOrTrialAccessによる自動解放をしない。
  excludeFromPlanUnlock?: boolean;
};

export const COURSES: CourseItem[] = [
  // 2026-10-14・CEO室依頼：一覧の並びは「使い方20選」を最上段、「2026 思考の参照点」をその下にする。
  // 2026-08-10・CEO室依頼「1万円層フェーズ1フロー」のテスト実装。
  // 既存の「◯◯版のための54の断章」（course_annual_*・hidden:true）とは別物：
  // あちらは54断章の本編プレースホルダー（未着手）、こちらは①めくる→②選ぶ→③並べ替え→
  // ④13枚語りを1本の流れで体験する導入フローの実働版（スタンダードのみ・テストアカウント限定）。
  // コピー全文は Dropbox「1万円層コンテンツ下書き_2026-08/スタンダード版.md」参照。
  // 【8/10・命名修正・Kazuto指摘】courseId/URLに「intro」を入れると、コース全体を指す識別子が
  // 「導入に過ぎず、他に細かく分割された購入コンテンツが控えている」ように見えてしまうため除去。
  // 表示ラベルも下書き原題「スタンダード版のための4×13」に戻す（サイドバーで折り返さない短さ、
  // Kazutoが変更を望まなかったため）。
  // 【8/20・CEO室→CTO室依頼で改称】「4×13」は8/8に撤回済みのスート×数字構造の名残のため、
  // Kazutoが8/14に仮置き確定していた新名称「スタンダード版の4つの使い方」に変更
  // （TASKS_ACTIVE.md 8/20エントリ参照）。依頼文は`/courses/standard`概要ページのh1のみを
  // 対象にしていたが、この一覧用labelも同じ旧称のままだったため合わせて修正。
  {
    courseId: "course_standard",
    label: "使い方20選",
    description: "めくる・選ぶ・並べ替える・カードの言葉を使う。この4つのカテゴリで定番の使い方を整理してあります。",
    href: "/courses/essentials",
    // 2026-10-14・CEO室依頼：鍵付きカードに購入ページへのリンクを出す（purchaseLinksがあっても
    // excludeFromPlanUnlock:true のため、自動解放の判定は変わらない）。
    purchaseLinks: [{ label: "購入する", url: "https://www.kataruta.com/products/kataruta-online-personal" }],
    // 2026-09-09・CEO室：着手保留解除（TASKS_ACTIVE.md 8/23〜9/9エントリ参照）。
    // adminOnly:trueを解除し一般ユーザーにも表示する（選択肢B・Shopify自動連携での
    // 購入導線構築に着手・shopifyGrantCourseStandard.ts参照）。
    // TODO（Kazuto）：Shopify商品ページ作成後、purchaseLinksに実際のURLを追加すること
    // （それまでは「コードをお持ちの方はこちら」のみ表示・購入ボタンは出ない状態のまま）。
    // excludeFromPlanUnlock:true＝サブスク会員・D30トライアル中の自動解放はしない
    // （8/26確定・購入者限定）。
    excludeFromPlanUnlock: true,
  },
  {
    courseId: "course_annual2026",
    label: "2026 思考の参照点",
    description: "365日分のお題と月ごとのガイドをたどりながら、思考を深めていくコースです。",
    href: "/courses/annual2026",
  },
  // 2026-08-29・CEO室：course統合方針の確定（TASKS_ACTIVE.md 8/29エントリ「course統合方針の
  // 確定＋¥20,000層実装の指示整理」参照）。course_tier2_2027という新規courseIdは廃止し、
  // 20選（4レッスン×5ステップ）・annualカレンダーはいずれもcourse_standard自身の拡張として
  // 実装する方針に変更された。¥10,000層（20選のみ）／¥20,000層（20選＋カレンダー）の判定は
  // course_standardのentitlementレベル（tier: "base"|"full"）で行う
  // （users/{uid}/courses/course_standardドキュメント。_useStandardCourseGate.ts参照）。
  // 2026-09-05・20選構造への文言更新（Kazuto承認・A案）：上記course_standardエントリの
  // label/descriptionを「4つの使い方」前提の旧文言から差し替え済み（OverviewView.tsxの同種の
  // 修正と対応）。
  {
    courseId: "course_7days",
    label: "7 Days｜視点発見コース",
    description: "7日間をかけて、ものの見方の発見を深めていくコースです。",
    href: "/courses/7days",
    comingSoon: true,
    hidden: true,
  },
  {
    courseId: "course_annual_standard",
    label: "スタンダード版のための54の断章",
    description: "スタンダード版のお題と月ごとのガイドをたどりながら、思考を深めていくコースです。",
    href: "/courses/annual/standard",
    comingSoon: true,
    adminOnly: true,
    hidden: true,
  },
  {
    courseId: "course_annual_logical",
    label: "ロジカル版のための54の断章",
    description: "ロジカル版のお題と月ごとのガイドをたどりながら、思考を深めていくコースです。",
    href: "/courses/annual/logical",
    comingSoon: true,
    adminOnly: true,
    hidden: true,
  },
  {
    courseId: "course_annual_storytelling",
    label: "ストーリーテリング版のための54の断章",
    description: "ストーリーテリング版のお題と月ごとのガイドをたどりながら、思考を深めていくコースです。",
    href: "/courses/annual/storytelling",
    comingSoon: true,
    adminOnly: true,
    hidden: true,
  },
  {
    courseId: "course_annual_life",
    label: "ライフ版のための54の断章",
    description: "ライフ版のお題と月ごとのガイドをたどりながら、思考を深めていくコースです。",
    href: "/courses/annual/life",
    comingSoon: true,
    adminOnly: true,
    hidden: true,
  },
  {
    courseId: "course_annual_emotion",
    label: "エモーション版のための54の断章",
    description: "エモーション版のお題と月ごとのガイドをたどりながら、思考を深めていくコースです。",
    href: "/courses/annual/emotion",
    comingSoon: true,
    adminOnly: true,
    hidden: true,
  },
];

export const TOOLS: CourseItem[] = [
  {
    courseId: "tool_thinking",
    label: "思考展開ワーク",
    description: "言葉を裏返したり、選んだりしながら、気になる並びを見つけて編集できるワークです。",
    href: "/work/thinking",
    purchaseLinks: [
      { label: "人生リバーシ 購入ページ", url: "https://www.kataruta.com/products/jinsei-reversi" },
      { label: "文法リバーシ 購入ページ", url: "https://www.kataruta.com/products/bunpo-reversi" },
    ],
  },
  {
    courseId: "tool_timeflow",
    label: "タイムフロー｜使い方をつくる",
    description: "動詞を組み合わせながら、タイムフローの使い方を自分なりに組み立てるワークです。",
    href: "/work/timeflow",
    purchaseLinks: [{ label: "購入ページ", url: "https://www.kataruta.com/products/timeflow" }],
  },
];
